var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"SectionPortfolio"},[_c('Wrap',[_c('Headline',[_vm._v(" "+_vm._s(_vm.$t('headline'))+" ")]),_c('CarouselGallery',{staticClass:"gallery",attrs:{"images":_vm.media}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }